import Vue from 'vue'

import { createNestedParams, createQueryGroup } from './util'
import { AdvancedSearchJobsMutations } from './partials/search-jobs'

export const AdvancedSearchMutations = {
  setEntities: (state, value) => {
    state.entities = value
  },
  setResultEntity: (state, value) => {
    state.entity = value
  },
  initAdvancedSearch: state => {
    state.query_groups = [createQueryGroup(1, null, {})]
    state.entity = null
    state.indistinctResults = false
  },
  setEmbeddedSearchQuery: (state, value) => { state.embeddedSearchQuery = value },
  setGroupEntity: (state, { id, entity, properties }) => {
    const group = createQueryGroup(id, entity, properties)
    const groupIndex = state.query_groups.findIndex(g => g.sequence === id)
    if (groupIndex >= 0) {
      group.nested_params = state.query_groups[groupIndex].nested_params
      state.query_groups.splice(groupIndex, 1, group)
    } else state.query_groups.push(group)
  },
  delQueryGroup: (state, id) => {
    const groupIndex = state.query_groups.findIndex(g => g.sequence === id)

    if (groupIndex < 0) return

    state.query_groups.splice(groupIndex, 1)
  },
  setNestedParam: (state, { id, sequence, union, update }) => {
    const group = state.query_groups.find(g => g.sequence === id)
    const paramsIndex = group.nested_params.findIndex(p => p.sequence === sequence)

    if (paramsIndex < 0) group.nested_params.push(createNestedParams(sequence, union))
    else if (update) group.nested_params[paramsIndex].logical_operator = union
    else group.nested_params.splice(paramsIndex, 1, createNestedParams(sequence, union))
  },
  delNestedParam: (state, { id, sequence }) => {
    const group = state.query_groups.find(g => g.sequence === id)
    const paramsIndex = group.nested_params.findIndex(p => p.sequence === sequence)

    if (paramsIndex < 0) return
    group.nested_params.splice(paramsIndex, 1)
  },
  setGroupProperty: (state, { id, property, sequence }) => {
    const group = state.query_groups.find(g => g.sequence === id)

    let params = group.entity_params
    if (sequence) params = group.nested_params.find(p => p.sequence === sequence)

    params.field = property
  },
  setGroupOperator: (state, { id, operator, sequence }) => {
    const group = state.query_groups.find(g => g.sequence === id)

    let params = group.entity_params
    if (sequence) params = group.nested_params.find(p => p.sequence === sequence)

    params.operator = operator
  },
  setGroupOptions: (state, { id, options, sequence }) => {
    const group = state.query_groups.find(g => g.sequence === id)

    let params = group.entity_params
    if (sequence) params = group.nested_params.find(p => p.sequence === sequence)

    Vue.set(params, 'options', options)
  },
  setGroupTerm: (state, { id, term, sequence }) => {
    const group = state.query_groups.find(g => g.sequence === id)

    let params = group.entity_params
    if (sequence) params = group.nested_params.find(p => p.sequence === sequence)

    params.term = term
  },
  setSearchedQueryGroups: state => {
    state.searched_query_groups = JSON.parse(JSON.stringify(state.query_groups))
  },
  setSearchResults: (state, results) => {
    state.search_results = results
  },
  setSearchLoading: (state, value) => {
    state.isSearching = value
  },
  setExportableFields: (state, value) => {
    state.exportable_fields = value
  },
  setQueryExportableFields: (state, value) => {
    state.exportable_fields_query = value
  },
  setShowExportDialog: (state, value) => {
    state.show_export_dialog = value
  },
  setSelectedResults: (state, value) => {
    state.selected_results = value
  },

  setIndistinctResults: (state, value) => {
    state.indistinctResults = value
  },

  setInterGroupOperator: (state, value) => {
    state.interGroupOperator = value
  },

  setLoadedJob (state, value) {
    state.loadedJob = value
  },

  setLoadingAdvancedSearch: (state, value) => { state.loadingAdvancedSearch = value },

  ...AdvancedSearchJobsMutations,
}
